import {NodeDefs} from "../parser/definition/types/NodeDefs";
import {compileFactoryLookup} from "./compileFactoryLookup";

export function compileLibrary(
  nodeDefs: NodeDefs
): string {
  return `const library = ${compileFactoryLookup(nodeDefs)};`;
}
